import React from "react";

export default function MaleIcon({ size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="38"
      viewBox="0 0 23 38"
      fill="none"
      style={{ transform: `scale(${size || 1})` }}
    >
      <g clip-path="url(#clip0_979_494)">
        <path
          d="M6.18764 36.1222L6.18754 36.1222L5.06849 35.7742C5.06841 35.7741 5.06834 35.7741 5.06827 35.7741C3.77315 35.3697 2.90002 34.1851 2.90002 32.8554V22.2647C2.90002 21.456 3.22465 20.6789 3.80513 20.1046L3.27766 19.5714L3.80514 20.1046C4.38589 19.5301 5.17527 19.2059 6.00002 19.2059H17C17.8248 19.2059 18.6142 19.5301 19.1949 20.1046C19.7754 20.6789 20.1 21.456 20.1 22.2647V32.8552C20.1 32.8553 20.1 32.8553 20.1 32.8554C20.0998 33.5041 19.8906 34.1368 19.5014 34.6613C19.1121 35.1861 18.5627 35.5756 17.9322 35.7718L16.8125 36.12L16.7927 36.1261L16.7733 36.1334L16.3664 36.285H15.9H14.8H12.6H8.53778H7.33426H6.85792C6.81229 36.2711 6.77128 36.263 6.73779 36.258C6.66708 36.2477 6.60659 36.2482 6.56488 36.2505C6.53679 36.252 6.51017 36.2548 6.48588 36.2581C6.39304 36.2007 6.29289 36.1549 6.18764 36.1222ZM6.97168 4.73729C8.17131 3.55049 9.80005 2.88232 11.5 2.88232C13.2 2.88232 14.8287 3.55049 16.0284 4.73729C17.2277 5.92381 17.9 7.53137 17.9 9.20585C17.9 10.8803 17.2277 12.4879 16.0284 13.6744C14.8287 14.8612 13.2 15.5294 11.5 15.5294C9.80005 15.5294 8.17131 14.8612 6.97168 13.6744C5.77233 12.4879 5.10002 10.8803 5.10002 9.20585C5.10002 7.53137 5.77233 5.92381 6.97168 4.73729Z"
          stroke="#878686"
          stroke-width="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_979_494">
          <rect
            width="22"
            height="37"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
